import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="invoice-amounts"
export default class extends Controller {
  static targets = ["type", "net", "tax", "total"]

  connect() {
    this.calculate()
  }

  calculate(event) {
    const trigger = event ? event.target : null
    const type = this.typeTarget.value
    const net = parseFloat(this.netTarget.value) || 0
    const total = parseFloat(this.totalTarget.value) || 0


    if (type === 'exempt_invoice') {
      this.handleExempt(trigger, net, total)
    } else {
      this.handleTaxable(trigger, net, total)
    }
  }

  handleExempt(trigger, net, total) {
    this.taxTarget.value = 0
    
    if (trigger === this.totalTarget) {
      this.netTarget.value = total
    } else {
      this.totalTarget.value = net
    }
  }

  handleTaxable(trigger, net, total) {
    const taxRate = 0.19

    if (trigger === this.totalTarget) {
      // From Total: Net = Total / 1.19
      const calculatedNet = Math.round(total / (1 + taxRate))
      this.netTarget.value = calculatedNet
      this.taxTarget.value = total - calculatedNet
    } else {
      // From Net (or Type change): Total = Net * 1.19
      const calculatedTax = Math.round(net * taxRate)
      this.taxTarget.value = calculatedTax
      this.totalTarget.value = net + calculatedTax
    }
  }
}
